module.exports = __webpack_public_path__ + "img/title.7e886bc7.png";